import React, { Component } from 'react'
import LoginLink from './LoginLink'
import { Link } from 'react-router-dom'
import BookingButton from '../booking/BookingButton'

class NavBar extends Component {
  constructor() {
    super()
    this.state = {
      isActive: false
    }
  }

  toggleNav = () => {
    this.setState({
      isActive: !this.state.isActive
    })
  }

  render = () => {
    let isActive = this.state.isActive ? 'is-active' : ''

    return (
      <nav className="navbar is-transparent automech-navbar">
        <div className="container">
          <div className="navbar-brand">
            <Link className="navbar-item" to="/" id="brand_logo">
              <img src="assets/images/logo_no_text.png" alt="automech logo" />
            </Link>
            <div
              className={'navbar-burger burger ' + isActive}
              data-target="navMenuIndex"
              onClick={this.toggleNav}>
              <span />
              <span />
              <span />
            </div>
          </div>
          <div id="navMenuIndex" className={'navbar-menu has-text-centered ' + isActive}>
            <div className="navbar-start">
              <div className="navbar-item">
                <Link className="has-text-black" to="/about" onClick={this.toggleNav}>
                  About
                </Link>
              </div>
              <div className="navbar-item">
                <Link className="has-text-black" to="/service" onClick={this.toggleNav}>
                  Services & Pricing
                </Link>
              </div>
              <div className="navbar-item">
                <Link className="has-text-black" to="faq" onClick={this.toggleNav}>
                  FAQ
                </Link>
              </div>
            </div>
            <div className="navbar-end">
              <div className="navbar-item">
                <LoginLink toggleNav={this.toggleNav} />
              </div>
              <div className="navbar-item">
                <BookingButton type="primary" className="orangeButton" size="large" />
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/layout/NavBar.js